import { Version } from "../../common/models/Version";
import { VersionResponse } from "../models/responses/VersionResponse";

export const VersionMapper = (data: VersionResponse): Version => {
  return {
    id: data._id,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    description: data.description,
    packageName: data.packageName,
    required: data.required,
    urlDownload: data.urlDownload,
    versionCode: data.versionCode,
    versionName: data.versionName
  }
}